import React, { Component, Fragment } from "react";
class Footer10 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const styles = this.props.data.cssfile;

    return (
      <>
        <footer className={styles.footer}>
          <div className={styles.copyright_content}>
            <p className={styles.copyright_label}>{this.props?.data?.footermenu?.text}
              <span className={styles.one_line_wrapper}> All Rights Reserved. <span className={styles.privacy_policyblock}> 
                <a href="/privacy-policy" target="_blank"  className={styles.privacy_policy}> Privacy Policy</a> | <a href="/terms-and-conditions" target="_blank"  className={styles.privacy_policy}>Terms & Conditions </a> </span> </span>
            </p>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer10;
